import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'app-input-currency-wrapper',
  templateUrl: './input-currency-wrapper.component.html',
  styleUrls: ['./input-currency-wrapper.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class InputCurrencyWrapperComponent implements OnInit {
  @Input() right = false;

  constructor() { }

  ngOnInit(): void {
  }

}
